/**
 * Provides access to device gyroscope data.
 */
export class GyroscopeInput {
  constructor() {
    this._orientation = {
      alpha: 0,
      beta: 0,
      gamma: 0,
    };

    this._isCapturing = false;
  }

  /**
  * Retrieves the current orientation data from the gyroscope.
  */
  orientation() {
    return this._orientation;
  }

  /**
  * Starts capturing gyroscope data from the device. 
  */
  start() {
    if (this._isCapturing) {
      return;
    }

    if (typeof window != 'undefined') {
      this._handleOrientation = event => {
        this._orientation.alpha = event.alpha;
        this._orientation.beta = event.beta;
        this._orientation.gamma = event.gamma;
      };

      window.addEventListener('deviceorientation', this._handleOrientation);
      this._isCapturing = true;
    }
  }

  /**
  * Stops capturing gyroscope data from the device.
  */
  stop() {
    if (!this._isCapturing) {
      return;
    }

    this._orientation = {
      alpha: 0,
      beta: 0,
      gamma: 0,
    };

    if (typeof window != 'undefined') {
      window.removeEventListener('deviceorientation', this._handleOrientation);
    }
    this._isCapturing = false;
  }

  /**
   * Checks if the device supports gyroscope input.
   */
  isSupported() {
    if (typeof window == 'undefined' || typeof DeviceOrientationEvent == 'undefined') {
      return false;
    }
    return true;
  }

  eventFrameEnd() {
    // No-op for now
  }

  /**
   * Requests user authorization for accessing the gyroscope.
   */
  async requestAuthorization() {
    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      try {
        const response = await DeviceOrientationEvent.requestPermission();
        if (response === 'granted') {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    } else {
      return true;
    }
  }
}

